import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { AgTechEnabledFeature, AgTechPublicFeature } from "@agtech/core/features/AgTechFeatures";

export const SaleFeatureDataGetFeaturesQuery: AgTechQuery<any, AgTechEnabledFeature[]> = {
    queryKey: () => ['Features'],
    query: async props => {
        return await props.http.getEntity<string[], AgTechEnabledFeature[]>({
            request: 'Features/Current',
            convert: data => data.map(f => ({
                name: f
            }))
        })
    },
    content: {
        loadingText: 'Loading Features...',
        failureText: 'Failed to load Features'
    }
}

export const SaleFeatureDataGetPublicFeaturesQuery: AgTechQuery<any, AgTechPublicFeature[]> = {
    queryKey: () => ['Features'],
    query: async props => {
        return await props.http.getEntity({
            request: 'Features',
        })
    },
    content: {
        loadingText: 'Loading Features...',
        failureText: 'Failed to load Features'
    }
}